import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Navbar";

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-6">
      <a
        href="/"
        data-testid="login-back-home"
        className="absolute top-8 left-8 flex items-center gap-2 text-white/50 hover:text-[#FFF200] transition-colors text-sm"
      >
        <ArrowLeft size={16} /> Torna al sito
      </a>

      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo className="items-center" />
          <h1 className="font-display text-2xl font-bold text-white mt-8">Area Riservata</h1>
          <p className="text-white/50 text-sm mt-1">Accedi per gestire viaggi ed eventi</p>
        </div>

        <form
          onSubmit={submit}
          data-testid="login-form"
          className="bg-[#121212] border border-white/10 rounded-2xl p-8 space-y-4"
        >
          <input
            required
            type="email"
            data-testid="login-email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors"
          />
          <input
            required
            type="password"
            data-testid="login-password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 bg-[#FFF200] text-black font-semibold py-3.5 rounded-full hover:bg-[#FFF200]/90 transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />}
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
